// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"86a685dd","290":"0ce1fd2e","458":"1414ebb6","531":"07e961f0","714":"b1c1c1ca","800":"7f7ad139","805":"d543eeff","897":"1854efe3","960":"81b96793"}[chunkId] + ".css";
};